<template>
  <div class="screen-wrap">
    <v-app class="hmc-app">
      <v-main class="main-body">
        <v-container class="app-body">
          <!-- BOC:[error] -->
          <ApiErrorDialog v-if="api.isError" :api="api" />
          <!-- EOC -->

          <!-- EOC -->
          <v-card class="px-2 pb-6 mx-auto" max-width="900">
            <v-card-title>
              Character Builder
              <v-spacer></v-spacer>
              <v-btn icon :to="{ name: 'PageWorldNews' }"><v-icon>mdi-home</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" class="d-flex flex-column justify-center align-center">
                  <div class="d-flex flex-column justify-center align-center text-center pa-6 my-4 avatar-container">
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.back"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.right"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.shadow"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.body"></v-img>
                    <v-img class="avatar colored-body" :style="{
                      '-webkit-mask-image': `url(${avatar.body})`,
                      'mask-image': `url(${avatar.body})`,
                      'background-color': `#${avatar.pColor}`,
                      '-webkit-mask-size': 'contain',
                      'mask-size': 'contain',
                      '-webkit-mask-repeat': 'no-repeat',
                      'mask-repeat': 'no-repeat',
                      '-webkit-mask-position': 'center',
                      'mask-position': 'center',
                      'width': '200px',
                      'height': '200px'
                    }"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.cheek"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.outline"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.mouth"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.hair"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.eye"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.left"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.hat"></v-img>
                    <v-img class="avatar" max-height="200" max-width="200" :src="avatar.mask"></v-img>
                  </div>

                  <v-card outlined class="pa-4 mb-4">
                    <v-card-text class="text-center pa-0">
                      Default Characters
                      <v-row class="mt-2 pa-0" justify="center" align="center" dense>
                        <v-col v-for="character in defaultCharacters" :key="character.name" cols="auto">
                          <v-btn rounded small :color="'#' + JSON.parse(character.avatar).pColor"
                            @click="selectDefaultCharacter(character)">
                            {{ character.name }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>

                  </v-card>


                </v-col>
                <v-col cols="12" sm="6" class="pt-5">
                  <v-select v-model="avatarBody" :items="bodyLayers" label="Body" item-text="character"
                    :item-value="item => item" @change="onBodyChange" outlined dense attach></v-select>

                  <v-select v-model="avatarMouth" :items="mouthLayers" label="Mouth" item-text="character"
                    :item-value="item => item" @change="onMouthChange" outlined dense attach></v-select>

                  <v-menu v-model="colorPickerMenu" :close-on-content-click="false" max-width="290">
                    <template #activator="{ on, attrs }">
                      <v-text-field v-model="avatarColor" label="Color" readonly v-bind="attrs" v-on="on" outlined dense
                        prepend-inner-icon="mdi-palette" :style="{ color: '#' + avatarColor }"></v-text-field>
                    </template>
                    <v-color-picker v-model="avatarColor" hide-inputs hide-mode-switch show-swatches flat
                      @change="onColorChange" @click="onColorChange" @input="onColorChange" />
                  </v-menu>

                  <v-select v-model="avatarLeft" :items="leftLayers" label="Left" item-text="name"
                    :item-value="item => item" @change="onLeftChange" outlined dense attach></v-select>

                  <v-select v-model="avatarRight" :items="rightLayers" label="Right" item-text="name"
                    :item-value="item => item" @change="onRightChange" outlined dense attach></v-select>

                  <v-select v-model="avatarBack" :items="backLayers" label="Back" item-text="name"
                    :item-value="item => item" @change="onBackChange" outlined dense attach></v-select>

                  <v-select v-model="avatarHat" :items="hatLayers" label="Hat" item-text="name"
                    :item-value="item => item" @change="onHatChange" outlined dense attach></v-select>

                  <v-select v-model="avatarMask" :items="maskLayers" label="Mask" item-text="name"
                    :item-value="item => item" @change="onMaskChange" outlined dense attach></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="px-5 mt-4">
              <code class="pa-2">{{ avatarJSON }}</code>
              <v-btn icon @click="copyJSON" :loading="api.isLoading">
                <v-icon small class="me-1">mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="green lighten-1" @click="downloadCanvas" :loading="api.isLoading" dark rounded
                class="text-h">
                <v-icon small class="me-1">mdi-download</v-icon> {{ $t("action.download") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  data: () => ({

    colorPickerMenu: false,

    bodyLayers: [],
    outlineLayers: [],
    mouthLayers: [],
    shadowLayers: [],
    eyeLayers: [],
    hairLayers: [],
    cheekLayers: [],
    backLayers: [],
    rightLayers: [],
    leftLayers: [],
    hatLayers: [],
    maskLayers: [],

    avatarBack: null,
    avatarRight: null,
    avatarLeft: null,
    avatarOutline: null,
    avatarMouth: null,
    avatarBody: null,
    avatarShadow: null,
    avatarEye: null,
    avatarHair: null,
    avatarCheek: null,
    avatarColor: null,
    avatarHat: null,
    avatarMask: null,

    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },

    avatar: {
      body: "",
      outline: "",
      mouth: "",
      shadow: "",
      eye: "",
      cheek: "",
      hair: "",
      pColor: "F1F1F1",
      hat: "",
      left: "",
      right: "",
      back: "",
      mask: "",
    },

    avatarJSON: {
      charKey: "mochi_v4",
      body: "",
      mouth: "",
      pColor: "F1F1F1",
      hat: "",
      left: "",
      right: "",
      back: "",
      mask: "",
    },

    defaultCharacters: [
      {
        name: "Hamochi",
        avatar: '{"charKey":"mochi_v4","body":"hamster","mouth":"hamster","pColor":"EEC883","hat":"S0010_H","left":"","right":"","back":""}',
      },
      {
        name: "Katy",
        avatar: '{"charKey":"mochi_v4","body":"cat","mouth":"cat","pColor":"FCE83F","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Beary",
        avatar: '{"charKey":"mochi_v4","body":"bear","mouth":"bear","pColor":"C67334","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Ruby",
        avatar: '{"charKey":"mochi_v4","body":"rabbit","mouth":"rabbit","pColor":"FFFFFF","hat":"","left":"","right":"","back":""}',
      },
    ],


  }),
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      settings: (state) => state.settings.data,
    }),
  },
  props: [
    //
  ],
  async created() {
    this.maskLayers = [
      {
        key: "",
        name: "No Item",
        image: ""
      },
      {
        key: "M0020",
        name: "Angry",
        image: require("@/assets/masks/M0020.png")
      },
      {
        key: "M0031",
        name: "Cry",
        image: require("@/assets/masks/M0031.png")
      },
      {
        key: "M0060",
        name: "Dizzy",
        image: require("@/assets/masks/M0060.png")
      },
      {
        key: "M0013",
        name: "Happy",
        image: require("@/assets/masks/M0013.png")
      },
      {
        key: "M0050",
        name: "Hungry",
        image: require("@/assets/masks/M0050.png")
      },
      {
        key: "M0012",
        name: "Laugh",
        image: require("@/assets/masks/M0012.png")
      },
      {
        key: "M0021",
        name: "Mad",
        image: require("@/assets/masks/M0021.png")
      },
      {
        key: "M0070",
        name: "Nervous 1",
        image: require("@/assets/masks/M0070.png")
      },
      {
        key: "M0071",
        name: "Nervous 2",
        image: require("@/assets/masks/M0071.png")
      },
      {
        key: "M0030",
        name: "Sad",
        image: require("@/assets/masks/M0030.png")
      },
      {
        key: "M0040",
        name: "Scare",
        image: require("@/assets/masks/M0040.png")
      },
      // {
      //   key: "M0080",
      //   name: "Shock",
      //   image: require("@/assets/masks/M0080.png")
      // },
      {
        key: "M0090",
        name: "Shout",
        image: require("@/assets/masks/M0090.png")
      },
    ]
    this.avatarMask = this.maskLayers[0]
    await this.loadApparel()
    await this.loadSkins()
  },
  mounted() {
    //
  },
  methods: {
    onBodyChange() {
      if (this.avatarBody) {
        this.avatarJSON.body = this.avatarBody.character;
        this.avatarOutline = this.outlineLayers.find(item => item.character === this.avatarBody.character);
        this.avatar.body = JSON.parse(this.avatarBody.images).F0.url;
        this.avatar.outline = JSON.parse(this.avatarOutline.images).F0.url;
      } else {
        this.avatarOutline = null;
        this.avatarJSON.body = "";
        this.avatar.body = "";
        this.avatar.outline = "";
      }
    },
    onMouthChange() {
      if (this.avatarMouth) {
        this.avatar.mouth = JSON.parse(this.avatarMouth.images).F0.url;
        this.avatarJSON.mouth = this.avatarMouth.character;
      } else {
        this.avatarJSON.mouth = "";
        this.avatar.mouth = "";
      }
    },
    onColorChange() {
      if (this.avatarColor) {
        const cleanColor = this.avatarColor.replace(/^#/, "");
        this.avatar.pColor = cleanColor;
        this.avatarJSON.pColor = cleanColor;
      } else {
        this.avatar.pColor = "";
        this.avatarJSON.pColor = "";
      }
    },
    onLeftChange() {
      if (this.avatarLeft && this.avatarLeft.key) {
        this.avatar.left = JSON.parse(this.avatarLeft.images).apparel.url;
        this.avatarJSON.left = this.avatarLeft.key;
      } else {
        this.avatarJSON.left = "";
        this.avatar.left = "";
      }
    },
    onRightChange() {
      if (this.avatarRight && this.avatarRight.key) {
        this.avatar.right = JSON.parse(this.avatarRight.images).apparel.url;
        this.avatarJSON.right = this.avatarRight.key;
      } else {
        this.avatarJSON.right = "";
        this.avatar.right = "";
      }
    },
    onBackChange() {
      if (this.avatarBack && this.avatarBack.key) {
        this.avatar.back = JSON.parse(this.avatarBack.images).apparel.url;
        this.avatarJSON.back = this.avatarBack.key;
      } else {
        this.avatarJSON.back = "";
        this.avatar.back = "";
      }
    },
    onHatChange() {
      if (this.avatarHat && this.avatarHat.key) {
        this.avatar.hat = JSON.parse(this.avatarHat.images).apparel.url;
        this.avatarJSON.hat = this.avatarHat.key;
      } else {
        this.avatarJSON.hat = "";
        this.avatar.hat = "";
      }
    },
    onMaskChange() {
      if (this.avatarMask && this.avatarMask.key) {
        this.avatar.mask = this.avatarMask.image;
        this.avatarJSON.mask = this.avatarMask.key;
      } else {
        this.avatarJSON.mask = "";
        this.avatar.mask = "";
      }
    },
    selectDefaultCharacter(character) {
      const avatarData = JSON.parse(character.avatar);

      this.avatarColor = '#' + avatarData.pColor ?? null;

      const bodyItem = this.bodyLayers.find(item => item.character === avatarData.body);
      this.avatarBody = bodyItem ?? null;

      const mouthItem = this.mouthLayers.find(item => item.character === avatarData.mouth);
      this.avatarMouth = mouthItem ?? null;

      const hatItem = this.hatLayers.find(item => item.key === avatarData.hat);
      this.avatarHat = hatItem ?? null;

      const leftItem = this.leftLayers.find(item => item.key === avatarData.left);
      this.avatarLeft = leftItem ?? null;

      const rightItem = this.rightLayers.find(item => item.key === avatarData.right);
      this.avatarRight = rightItem ?? null;

      const backItem = this.backLayers.find(item => item.key === avatarData.back);
      this.avatarBack = backItem ?? null;


      this.onBodyChange();
      this.onMouthChange();
      this.onColorChange();
      this.onLeftChange()
      this.onRightChange()
      this.onHatChange()
      this.onBackChange()
    },
    exit() {
      this.$router.push({
        name:
          this.auth.Group.type == "family"
            ? "PageAccessFamily"
            : "PageAccessClassroom",
      });
    },
    async downloadCanvas() {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 512;
      canvas.height = 512;

      const loadImage = (src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => resolve(img);
          img.onerror = (err) => {
            console.error("Image failed to load:", src, err);
            reject(err);
          };
          img.src = src;
        });
      };

      try {
        this.api.isLoading = true;

        // 1. Draw Back
        if (this.avatar.back) {
          const img = await loadImage(this.avatar.back);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }

        // 2. Draw Right
        if (this.avatar.right) {
          const img = await loadImage(this.avatar.right);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }

        // 3. Draw Shadow
        if (this.avatar.shadow) {
          const img = await loadImage(this.avatar.shadow);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }

        // 4. Draw Body with color masking in a separate layer
        if (this.avatar.body) {
          const bodyImg = await loadImage(this.avatar.body);

          // Create temp canvas
          const tempCanvas = document.createElement("canvas");
          tempCanvas.width = canvas.width;
          tempCanvas.height = canvas.height;
          const tempCtx = tempCanvas.getContext("2d");

          // Draw the body
          tempCtx.drawImage(bodyImg, 0, 0, canvas.width, canvas.height);

          // Color it with pColor
          if (this.avatar.pColor) {
            tempCtx.globalCompositeOperation = "source-in";
            tempCtx.fillStyle = `#${this.avatar.pColor}`;
            tempCtx.fillRect(0, 0, canvas.width, canvas.height);
          }

          // Draw the masked body onto the main canvas
          ctx.drawImage(tempCanvas, 0, 0);
        }

        // 5. Draw Outline
        if (this.avatar.outline) {
          const img = await loadImage(this.avatar.outline);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }

        // 6. Draw Top Layers
        const topLayers = [
          this.avatar.cheek,
          this.avatar.mouth,
          this.avatar.hair,
          this.avatar.eye,
          this.avatar.left,
          this.avatar.hat,
          this.avatar.mask
        ];

        for (const src of topLayers) {
          if (!src) continue;
          const img = await loadImage(src);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }

        // 7. Download the result
        const link = document.createElement("a");
        link.download = "avatar.png";
        link.href = canvas.toDataURL();
        link.click();

      } catch (e) {
        console.error("Download failed:", e);
        this.api.isError = true;
      } finally {
        this.api.isLoading = false;
      }
    },
    copyJSON() {
      const text = JSON.stringify(this.avatarJSON, null, 2);
      navigator.clipboard.writeText(text).then(() => {
        // Show "Copied!" message
        this.$toast && this.$toast.success("Copied!", { duration: 2000 });
        // OR fallback:
        if (!this.$toast) {
          const msg = document.createElement("div");
          msg.textContent = "Copied!";
          msg.style.position = "fixed";
          msg.style.bottom = "20px";
          msg.style.left = "50%";
          msg.style.transform = "translateX(-50%)";
          msg.style.background = "rgba(0,0,0,0.7)";
          msg.style.color = "#fff";
          msg.style.padding = "10px 20px";
          msg.style.borderRadius = "8px";
          msg.style.zIndex = "9999";
          document.body.appendChild(msg);
          setTimeout(() => document.body.removeChild(msg), 2000);
        }
      });
    },
    async loadSkins() {
      this.api.method = "get";
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/library/skin/load";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;

        this.bodyLayers = resp.filter(item => item.layer === "body");
        this.outlineLayers = resp.filter(item => item.layer === "outline");
        this.mouthLayers = resp.filter(item => item.layer === "mouth");
        this.shadowLayers = resp.filter(item => item.layer === "shadow");
        this.eyeLayers = resp.filter(item => item.layer === "eye");
        this.hairLayers = resp.filter(item => item.layer === "hair");
        this.cheekLayers = resp.filter(item => item.layer === "cheek");

        this.avatar.body = JSON.parse(this.bodyLayers[0].images).F0.url;
        this.avatar.mouth = JSON.parse(this.mouthLayers[0].images).F0.url;
        this.avatar.eye = JSON.parse(this.eyeLayers[0].images).F0.url;
        this.avatar.cheek = JSON.parse(this.cheekLayers[0].images).F0.url;
        this.avatar.hair = JSON.parse(this.hairLayers[0].images).F0["url"];
        this.avatar.outline = JSON.parse(this.outlineLayers[0].images).F0["url"];
        this.avatar.shadow = JSON.parse(this.shadowLayers[0].images).F0["url"];

        this.avatarJSON.body = this.bodyLayers[0].character
        this.avatarJSON.mouth = this.mouthLayers[0].character;

        this.avatarBody = this.bodyLayers[0];
        this.avatarMouth = this.mouthLayers[0];
        this.avatarColor = '#' + this.avatar.pColor;
      };
      await this.$api.fetch(this.api);
    },
    async loadApparel() {
      this.api.method = "get";
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/library/apparel/load";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;

        // Clear previous arrays
        this.leftLayers = [];
        this.rightLayers = [];
        this.backLayers = [];
        this.hatLayers = [];

        // Sort into arrays by key suffix
        resp.forEach(item => {
          if (item.key.endsWith("_L")) {
            this.leftLayers.push(item);
          } else if (item.key.endsWith("_R")) {
            this.rightLayers.push(item);
          } else if (item.key.endsWith("_B")) {
            this.backLayers.push(item);
          } else if (item.key.includes("_H") || !item.key.includes("_")) {
            this.hatLayers.push(item);
          }
        });

        // Sort arrays by ascending alphabetical order by 'name'
        const sortByName = (a, b) => {
          if (!a.name) return 1;
          if (!b.name) return -1;
          return a.name.localeCompare(b.name);
        };

        this.leftLayers = this.leftLayers.sort(sortByName);
        this.rightLayers = this.rightLayers.sort(sortByName);
        this.backLayers = this.backLayers.sort(sortByName);
        this.hatLayers = this.hatLayers.sort(sortByName);

        // Add "no-item" at the start of each list
        const noItem = { key: "", name: "No Item", };

        this.leftLayers.unshift(noItem);
        this.rightLayers.unshift(noItem);
        this.backLayers.unshift(noItem);
        this.hatLayers.unshift(noItem);

        // Set defaults if available (choose first which will be no-item now if no others)
        if (this.leftLayers.length) {
          this.avatarLeft = this.leftLayers[0];
          this.avatar.left = this.avatarLeft.key ? JSON.parse(this.avatarLeft.images).apparel.url : "";
          this.avatarJSON.left = this.avatarLeft.key;
        }
        if (this.rightLayers.length) {
          this.avatarRight = this.rightLayers[0];
          this.avatar.right = this.avatarRight.key ? JSON.parse(this.avatarRight.images).apparel.url : "";
          this.avatarJSON.right = this.avatarRight.key;
        }
        if (this.backLayers.length) {
          this.avatarBack = this.backLayers[0];
          this.avatar.back = this.avatarBack.key ? JSON.parse(this.avatarBack.images).apparel.url : "";
          this.avatarJSON.back = this.avatarBack.key;
        }
        if (this.hatLayers.length) {
          this.avatarHat = this.hatLayers[0];
          this.avatar.hat = this.avatarHat.key ? JSON.parse(this.avatarHat.images).apparel.url : "";
          this.avatarJSON.hat = this.avatarHat.key;
        }
      };
      await this.$api.fetch(this.api);
    }
  },
};
</script>
<style scoped>
.avatar {
  position: absolute;
}

.colored-body {
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

.title {
  pointer-events: none;
  font-size: 1em !important;
}

.app-body {
  min-height: 100%;
  padding: 50px 10px;
}

.main-body {
  background-color: rgb(222, 194, 162);
}

.avatar-container {
  position: relative;
  width: 200px;
  height: 200px;
}
</style>